import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-tooltip', 'open', 'Открыть подсказку');
Labels.set('ui-tooltip', 'close', 'Закрыть подсказку');
